import React from 'react'

import SmallButton from '../../../../components/display/Button/Small'

import { Buttons } from '../shared'

const pluralizedButtonText = (count: number) => {
  switch (count) {
    case null:
    case undefined:
      return 'See results'
    case 0:
      return 'See 0 results'
    case 1:
      return 'See 1 result'
    default: {
      return `See ${count?.toLocaleString()} results`
    }
  }
}

type Props = {
  onClear: () => any
  clearLabel?: string
  onView: () => any
  resultsCount?: number
}

const FilterPanelActions = ({
  clearLabel = 'Clear',
  onClear,
  onView,
  resultsCount,
}: Props) => {
  const buttonText = pluralizedButtonText(resultsCount)

  return (
    <Buttons>
      <SmallButton
        type="button"
        onClick={onClear}
        uppercase={false}
        ghost
        noHover
      >
        {clearLabel}
      </SmallButton>
      <SmallButton
        type="button"
        onClick={onView}
        uppercase={false}
        data-testid="see-results"
      >
        {buttonText}
      </SmallButton>
    </Buttons>
  )
}

export default FilterPanelActions
